import "../team/styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import Button from "../../../components/UI/button/GgButton";
import { Context } from "../../..";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import Spinner from "../../../components/UI/spinner/Spinner";
import ContactUs from "./blocks/ContactUs";
import { IBlocks, IContent, IHeader } from "../../../models/IPages";
import {
  createFileFromBase64,
  getImageExtensionFromBase64,
  removeKeyFromObject,
} from "../../../utils";

const Contact: FC = () => {
  const { pages, store, roles } = useContext(Context);
  const [adminPermissionData, setAdminPermissionData] = useState<any>();
  const categoryType = window.location.pathname.split("/").pop() || "";
  const [contactBlock, setContactBlock] = React.useState<IBlocks>({
    title: "",
    description: "",
    content: Array.from({ length: 4 }, () => ({
      heading: "",
      image: "",
    })),
    images: [],
  });

  useEffect(() => {
    pages
      .loadList(categoryType)
      .then((res: any) => {
        handleFillData(res.content);
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    [contactBlock].forEach((object, index) => {
      // remove base64 images from object
      const filteredObject = removeKeyFromObject(object, "images");
      // Convert object data to JSON string
      const objectData = JSON.stringify(filteredObject);
      const objectKey = Object.keys({
        contactBlock,
      })[index];

      formData.append(objectKey, objectData);
      // Add images to the FormData
      if (object?.images && object.images.length > 0) {
        object.images.forEach((base64Image: string, imageIndex: number) => {
          if (base64Image) {
            let base64Data =
              base64Image?.split(",")?.[1] ||
              base64Image?.split(";base64,").pop() ||
              "";
            const ext = getImageExtensionFromBase64(base64Image);

            console.log("IMAGE EXTENSION", ext);

            const image = createFileFromBase64(
              base64Data,
              `${objectKey}${imageIndex + 1}.${ext || "jpg"}`,
              `image/${ext || "jpg"}`
            );

            formData.append(`${objectKey}${imageIndex + 1}`, image);
          }
        });
      }
    });
    pages
      .updateOne(categoryType, formData)

      .then(() => {
        pages
          .loadList(categoryType)
          .then((res: any) => {
            handleFillData(res.content);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  const handleFillData = (content: any) => {
    if (content) {
      setContactBlock(content[0].contactBlock);
    }
  };

  useEffect(() => {
    loadNewData();
  }, []);

  const loadNewData = async () => {
    const userData = store?.user?.role
      ?.find((par: any) => par?.path === "pages")
      ?.children?.find((child: any) => child.path === "contactDetails");
    setAdminPermissionData(userData);
  };
  return (
    <div className="Contact-page">
      {Object.keys(pages.pageContent).length > 0 &&
      !pages.loadingContentBool ? (
        <form className="body" onSubmit={handleSave}>
          {/* TODO: info block applied   */}
          <ContactUs
            data={contactBlock}
            setData={setContactBlock}
            categoryType={categoryType}
            actionData={adminPermissionData}
          />
          <div className="btn-container">
            {adminPermissionData?.edit || adminPermissionData?.delete ? (
              <Button className="button" label="Save" type="submit" />
            ) : (
              ""
            )}
          </div>
        </form>
      ) : Object.keys(pages.pageContent).length === 0 &&
        !pages.loadingContentBool ? (
        <Emptiness icon={Timofey} content="It's time to create some content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default observer(Contact);
